import { LoadingIndicator } from "@/components/_untitled/application/loading-indicator/loading-indicator.tsx";

interface LoadingOverlayProps {
    isVisible?: boolean;
    size?: "sm" | "md" | "lg" | "xl";
    type?: "line-simple" | "line-spinner" | "dot-circle";
    label?: string;
}

export const LoadingOverlay = ({ 
    isVisible = true,
    size = "sm", 
    type = "line-simple", 
    label 
}: LoadingOverlayProps) => {
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/20">
            <div className="bg-white rounded-lg p-4 shadow-lg">
                <LoadingIndicator type={type} size={size} label={label} />
            </div>
        </div>
    );
};